import { render } from "./TopCustomersComponent.vue?vue&type=template&id=1bd963f2"
import script from "./TopCustomersComponent.vue?vue&type=script&lang=js"
export * from "./TopCustomersComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/dashboard/TopCustomersComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bd963f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bd963f2', __exports__)) {
    api.reload('1bd963f2', __exports__)
  }
  
  module.hot.accept("./TopCustomersComponent.vue?vue&type=template&id=1bd963f2", () => {
    api.rerender('1bd963f2', render)
  })

}


export default __exports__